<template>
  <div class="c-page u-relative">
      <section    data-color="dark" class="u-relative u-fit-w u-bg--brand-dark u-overflow-h js-header-panel">
        <div class="c-page__header o-wrapper--panel" :style="'transform:translateX(' + headerPageSize[2] + 'px) translateY('+headerPageSize[3]+'px) scale('+headerPageSize[4]+')'" >
                     <img src="/static/HeadImages/operations.jpg" class="u-absolute u-pos-tl" :style="'width:' + headerPageSize[0] + 'px; height:'+headerPageSize[1]+'px' ">
         </div>
         <div class="o-wrapper--valign u-viewport-fit-h u-fit-w">
             <div class="u-relative u-inline-block c-top-maintitle u-pos-x-center u-align-center">
               <span class="c-page__subtitle  t-hh1 t-text-ls--md t-text--roman u-color--white u-align-center  u-inline-block " v-html="content.subtitle"></span>
                 <h1 class="t-h2-sub  t-text-lh--md u-color--white u-align-center  u-marg-b-lg">
                     <app-sliced-text :content="content.title"></app-sliced-text>
                 </h1>
               </div>
         </div>
         <button v-scroll-to="'#start'" class="c-home__scroll-btn c-btn-scroll  u-pos-x-center t-btn u-absolute u-inline-block  u-marg-b-md@sm">
          <img src="/static/common/MainLogoWhite -arrow-white2.svg"  width="32px" >
          </button>
      </section>

      <section :data-color="item.dataColor"   v-for="(item, index)  in content.blocks"     class="u-relative u-overflow-h u-fit-w  u-pad-x-w2of12  u-pad-x-w1of12@sm   js-header-panel" :class="[item.bgColorClass,{'u-pad-t-xl':index===0,'u-pad-b-xl':content.blocks.length-1==index}]" >
      <!--  <div  class="u-absolute u-pos-br u-opacity--40@sm" v-if="index===0">
          <img src="/static/technology/technology-image-1.jpg" class="u-fit u-disp-block">
        </div>
        <div v-if="index===1" class="c-page__header o-wrapper--panel " :style="myStylesTransform2">
                <img src="/static/technology/technology-image-2.jpg" class="u-absolute u-pos-tl u-fit u-object-fit-cover  u-opacity--74@sm" :style="myStylesWidthHeight">
        </div>
        <div  class="u-absolute u-pos-bl u-opacity--40@sm" v-if="index===1">
          <img src="/static/technology/technology-image-2.jpg" class="u-fit u-disp-block">
        </div>
        <div  class="u-absolute u-pos-br u-opacity--40@sm" v-if="index===2">
          <img src="/static/technology/technology-image-3.jpg" class="u-fit u-disp-block">
        </div>
        <div  class="u-absolute u-pos-bl u-opacity--40@sm" v-if="index===3">
          <img src="/static/technology/technology-image-4.jpg" class="u-fit u-disp-block">
        </div>-->
          <div   class="c-investors__section u-relative u-flex  u-flex-fd--column@sm  u-zindex--2" v-if="item.special==='special-right'">
            <div class=" u-marg-b-lg@sm u-w1of2   u-pad-l-0@lg u-fit-w@sm" :class="{'u-pad-l-w1of8':item.padLeft==='1'}">
            </div>
               <div class="u-marg-b-lg@sm u-w1of2   u-pad-l-0@lg u-fit-w@sm" :class="{'u-pad-l-w1of8':item.padLeft==='1'}">
                  <div>
                      <app-scroll-object :offset=".05" :isParallax="!1" inline-template :content="item">
                        <div class="w2of10 u-w1of3@md u-fit-w@sm">
                          <h1 class="t-h1 t-text--roman u-relative u-marg-r-0@sm u-color--gray"  :class="{'u-color--brand-dark':content.color==='dark','u-color--white':content.color==='white'}">
                              <span class="c-number-offset__Qfly-technology t-text--xl--Bold  u-absolute u-pos-bl" ></span>
                              <app-words  :isActive="isActive" :delay="10" :content="content.title"></app-words><app-words  :isActive="isActive" :delay="10" :classc="'t-title--nl-technology u-color--LightBlueTitle'" :content="content.title2"></app-words>
                            </h1>

                        </div>
                      </app-scroll-object>
                  </div>
                  <div :key="indexin" v-for="(itemin, indexin)  in item.content">
                      <h6 class="t-text--xl t-text-lh--md t-text--xl u-pad-t-lg" v-if="'title'===itemin.type.value" :class="[{'t-text--md--bold':itemin.bold==='true','u-color--brand-dark':itemin.color==='dark','u-color--white':itemin.color==='white','u-color--gray':itemin.color==='gray'},itemin.textalign]">
                          <app-scroll-object   :offset=".05"  :isParallax="!1" inline-template  :content="itemin" >
                               <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                           </app-scroll-object >
                        </h6>
                      <div class="u-marg-t-md t-text--xl" v-if=" 'default'===itemin.type.value" :class="[{'u-marg-t-md':indexin>0,'u-color--lightblue':itemin.color==='dark','u-color--white':itemin.color==='white'},itemin.textalign]" v-html="itemin.content"> </div>
                  </div>
              </div>
            </div>
            <a id="start">
            <div   class="c-investors__section u-relative u-flex  u-flex-fd--column@sm  u-zindex--2" v-if="item.special==='special-all-left'">
                <div class="u-marg-b-lg@sm u-w2of2   u-pad-l-0@lg u-fit-w@sm" :class="{'u-pad-l-w1of8':item.padLeft==='1'}">
                    <div>
                        <app-scroll-object :offset=".05" :isParallax="!1" inline-template :content="item">
                          <div class="w2of10 u-w1of3@md u-fit-w@sm">
                            <h1 class="t-text--roman u-relative u-marg-r-0@sm" :class="[{'u-color--brand-dark':content.color==='dark','u-color--LightBlueTitle':content.color==='lblue'},content.pushtitle,content.textsize]">
                               <span class="c-number-offset__first_Qconcept t-text--xl--Bold  u-absolute u-pos-bl" v-if="content.islinetop==true" ></span>
                               <span class="c-number-offset__first_Qconcept-text t-text--sm u-color--LightBlueTitle u-absolute u-pos-bl"  v-if="content.islinetoptext==true">{{content.linetoptext}}</span>
                               <span class="c-number-offset__number_Qconcept  t-title--nl-technology u-color--brand-dark u-absolute u-pos-bl"  v-if="content.isNumberEnabled==true">{{content.NumberText}}</span>
                               <span class="c-number-offset__first_Qconcept t-text--xl--Bold  u-absolute u-pos-bl" v-if="content.islinetop==true" ></span>
                                <app-words  :isActive="isActive" :delay="4" :content="content.title"></app-words><app-words  :isActive="isActive" :delay="10" :classc="'t-title--nl-technology u-color--darkBlueTitle'" :content="content.title2"></app-words>
                              </h1>
                          </div>
                        </app-scroll-object>
                    </div>
                    <div :key="indexin" v-for="(itemin, indexin)  in item.content">
                        <h6 class="t-text--xl t-text-lh--md t-text--xl u-pad-t-lg" v-if="'title'===itemin.type.value" :class="{'t-text--md--bold':itemin.bold==='true','u-color--brand-dark':itemin.color==='dark','u-color--white':itemin.color==='white','u-color--gray':itemin.color==='gray'}">
                            <app-scroll-object   :offset=".05"  :isParallax="!1" inline-template  :content="itemin" >
                                 <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                             </app-scroll-object >
                          </h6>
                        <div class="u-marg-t-md t-text--xl" v-if=" 'default'===itemin.type.value" :class="[{'u-marg-t-md':indexin>0,'u-color--brand-dark':itemin.color==='dark','u-color--white':itemin.color==='white'},itemin.textalign]" v-html="itemin.content"> </div>
                    </div>
                </div>
              </div>
              </a>
        </section>
       <app-footer :globalContent="globalContent" :adminContent="adminContent"></app-footer>
  </div>

  </template>

  <script>

  import AppFooter from '../app-footer/index.vue'
  import AppScrollObject from '../app-scroll-object/index.vue'
  import AppSlicedText from '../app-sliced-text/index.vue'
  import AppRiskTools from '../app-sliced-text/index.vue'
 
  export default {
      props: {
        debug: {
            type: Boolean,
            default: !1
        },
          adminContent: {
              type: Object,
              default: function() {}
          },
          globalContent: {
              type: Object,
              default: function() {}
          },
          headerPageSize: {
              type: Array,
              default: function() {}
          }
      },
      components: {
          "app-footer": AppFooter,
          "app-scroll-object": AppScrollObject,
          
          "app-sliced-text": AppSlicedText,
          "app-risk-tools": AppRiskTools
      },
      computed: {
          content: function() {
              return this.adminContent.en.pages.companyprofile
          },
          myStylesTransform2() {
              return {
                  transform: 'translateX(' + this.headerPageSize[2] + 'px) translateY(' + this.headerPageSize[3] + 'px) scale(' + this.headerPageSize[4] + ')'

              }

          },
          myStylesWidthHeight() {
              return {
                  width: this.headerPageSize[0] + "px",
                  height: this.headerPageSize[1] + "px"

              }
          },
          myStylesWidthHeight11() {
              return {
                  width: "1600px",
                  height: "900px"

              }
          }
      },
      created: function() {
          this.eventHub.$on("resize", this.onResize)
      },
      destroyed: function() {
          this.eventHub.$off("resize", this.onResize)
      },
      mounted: function() {

          this.onResize(),
              this.eventHub.$emit("page:ready")
      },
      data: function() {
          return {

            

          }
      },
      methods: {
          onResize: function() {}
      }

  }

  </script>
